import * as React from "react";
import { forwardRef, memo } from "react";
const SvgOvalWhite = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 23, viewBox: "0 0 22 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M21.5 11.0078C21.5 16.8068 16.799 21.5078 11 21.5078C5.20101 21.5078 0.5 16.8068 0.5 11.0078C0.5 5.20882 5.20101 0.507812 11 0.507812C16.799 0.507812 21.5 5.20882 21.5 11.0078Z", fill: "white", stroke: "#9E9FAC" }));
const ForwardRef = forwardRef(SvgOvalWhite);
const Memo = memo(ForwardRef);
export default Memo;
